import polimix from "../custom/polimix"
import consorciolmm from "../custom/consorciolmm"
import consorciocohab9 from "../custom/consorciocohab9"
import cymaco from "../custom/cymaco";

const customers = {
    polimix,
    consorciolmm,
    cymaco,
    consorciocohab9
}

//LOGAR NOVAMENTE PARA FUNCIONAR!!!

let routes = [] //Rotas que serão inseridas fora do padrão
let remove = [] //Rotas que serão removidas do padrão

if (localStorage.getItem('account')) {

    const account = JSON.parse(localStorage.getItem('account'))
    const domain = account.domain

    if (account.custom) {
        if (customers[domain]) {
            routes = customers[domain].routes
            remove = customers[domain].remove
        } else {
            console.log("Módulo custom: " + domain + " não importado e/ou não inserido no array customers")
            alert('Falha módulo não registrado')
        }
    }
}

export default {
    routes,
    remove
}
